<template>
    <div class="system_log">
        <div style="padding: 20px">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>系统管理</el-breadcrumb-item>
                <el-breadcrumb-item>登陆日志</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div style="padding: 30px">
            <el-table :data="tableData"
                      height="700"
                      border
                      style="width: 100%">
                <el-table-column
                        align="center"
                        type="index"
                        label="序号"
                        width="60">
                </el-table-column>
                <el-table-column
                        align="center"
                        prop="userName"
                        label="账号">
                </el-table-column>
                <el-table-column
                        align="center"
                        prop="date"
                        label="日期">
                    <template slot-scope="scope">
                        {{scope.row.logTime}}
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        prop="operation"
                        label="日志内容">
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import dayjs from 'dayjs'
    export default {
        name: "Systemlog",
        data() {
            return {
                tableData: []
            }
        },
        mounted() {
            this.getloglist()
        },
        methods: {
            getloglist(){
                let url = '/log/list';
                this.$axios.get(url).then((resp)=>{
                    console.log(resp);
                    if(resp.data.code === 200){
                        this.tableData = resp.data.result;
                        for (let i = 0; i < this.tableData.length; i++) {
                            this.tableData[i].logTime = dayjs(this.tableData[i].logTime).format('YYYY-MM-DD HH:mm:ss')
                        }
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .system_log {

    }
</style>